import http from "../utils/http-common";

const get = (id: number) => {
  return http.get(`/equipment/${id}`);
};
const put = (id: number, data: any) => {
  return http.put(`/equipment/${id}`, data);
};
const remove = (id: number) => {
  return http.delete(`/equipment/${id}`);
};
const post = (data: any) => {
  return http.post(`/equipment`, data);
};
const getAll = () => {
  return http.get(`/equipment`);
};
export const equipmentService = {
  get,
  put,
  remove,
  post,
  getAll,
};

export default equipmentService;
